import { Injectable } from '@angular/core';
import { map, Subject, takeUntil } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { Router } from '@angular/router';
import { NotificationService } from './notifications.service';
import { activeTranslations } from '../enum/constants';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
// URLs
  private profileUrl = environment.baseURL + '/profile/';
  private profilePhoneUrl = environment.baseURL + '/profile/phone';
  private profilePasswordUrl = environment.baseURL + '/users/password';
  private profileAvatarUrl = environment.baseURL + '/profile/avatar';
  private profileAdditionalUrl = environment.baseURL + '/profile/additional';

// Destroy
  private readonly destroy$ = new Subject<null>();

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
  ) {
  }

  public update(data: any) {
    return this.http.put<any>(this.profileUrl, data)
      .pipe(map(res => res.data));
  }


  public updatePhone(phone: string) {
    return this.http.post<any>(this.profilePhoneUrl, { phone })
      .pipe(map(res => res.data));
  }

  public createAdditional(payload: any) {
    return this.http.post<any>(this.profileAdditionalUrl, payload)
      .pipe(map(res => res.data));
  }

  public checkPhone() {
    this.baseService.getProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (!response.phone) {
            this.router.navigate(['/additional']);
          }
        },
        error: (e) => {
          this.notificationService.showError(activeTranslations.notifications_texts.error.error, activeTranslations.notifications_texts.error.error_getting_profile);
        },
      });
  }


  changePassword(data: { new_password: string; confirm_password: string }) {
    return this.http.put<any>(this.profilePasswordUrl, data)
      .pipe(map(res => res.data));
  }

  changeAvatar(file: File) {
    const formData = new FormData();
    formData.append('docId', 'opppp');
    formData.append('file', file);
    const headers = new HttpHeaders({
      // 'Content-Type': 'multipart/form-data; boundary {}',
      'Content-Type': 'multipart/form-data',
    });

    return this.http.post(this.profileAvatarUrl, formData);
  }
}
